define('home/views/ActivityCardCollectionView',[
    'underscore',

    'home/views/ActivityCardWrapperView',
    'home/views/common/FetchableCollectionView',
    'home/views/FeedEmptyView',

    'home/mixins/withViewFeedTracking',
    'home/mixins/withClickLinkTracking',
], function (
    _,

    ActivityCardWrapperView,
    FetchableCollectionView,
    FeedEmptyView,

    withViewFeedTracking,
    withClickLinkTracking
) {
    'use strict';

    var ActivityCardCollectionView = FetchableCollectionView.extend({
        className: 'cards',
        emptyView: FeedEmptyView,

        itemView: ActivityCardWrapperView,

        events: _.defaults({
            'click a[data-link-name]': function (evt) {
                // Only track click events on the activity cards. Leave tracking on other cards
                // (such as empty view cards) to the subviews
                if (!this.isShowingNonItemView())
                    this.trackClickLink(evt);
            },
        }, FetchableCollectionView.prototype.events),
    });

    withViewFeedTracking.call(ActivityCardCollectionView.prototype);
    withClickLinkTracking.call(ActivityCardCollectionView.prototype);

    return ActivityCardCollectionView;
});

